module.exports = __webpack_public_path__ + "static/img/none.1586ef4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/card/none.png
// module id = Fhre
// module chunks = 1